export const adminMessages = {
  'admin.btn.cancel': '取消',
  'admin.btn.delete': '删除',
  'admin.btn.edit': '编辑',
  'admin.btn.query': '查询',
  'admin.btn.reset': '重置',
  'admin.btn.save': '保存',
  'admin.category.col.actions': '操作',
  'admin.category.col.count': '商品数',
  'admin.category.col.name': '名称',
  'admin.category.col.sort': '排序',
  'admin.category.col.status': '状态',
  'admin.category.confirmDel': '确定删除该分类吗？',
  'admin.category.empty': '暂无分类数据',
  'admin.category.formAdd': '新增分类',
  'admin.category.formEdit': '编辑分类',
  'admin.category.list': '分类列表',
  'admin.category.nameEnPh': '英文分类名称',
  'admin.category.namePh': '分类名称',
  'admin.category.save': '保存分类',
  'admin.category.sortPh': '排序值',
  'admin.category.sub': '维护商品一级/二级分类，控制启用状态和排序权重',
  'admin.category.title': '分类管理',
  'admin.form.back': '← 返回',
  'admin.form.basic': '基础信息',
  'admin.form.catPlaceholder': '请选择分类',
  'admin.form.category': '商品分类',
  'admin.form.cover': '封面图 URL',
  'admin.form.coverPh': '粘贴图片链接',
  'admin.form.descEnLabel': '英文描述',
  'admin.form.descEnPh': '请输入英文描述',
  'admin.form.descLabel': '商品描述',
  'admin.form.descPh': '请输入商品描述，建议 30-200 字',
  'admin.form.display': '展示信息',
  'admin.form.err.cat': '请选择商品分类',
  'admin.form.err.name': '商品名称不能为空',
  'admin.form.err.price': '售价必须大于 0',
  'admin.form.err.sku': '商品编号不能为空',
  'admin.form.err.stock': '库存不能为负数',
  'admin.form.name': '商品名称',
  'admin.form.nameEn': '英文名称',
  'admin.form.nameEnPh': '请输入英文名称',
  'admin.form.namePh': '请输入商品名称',
  'admin.form.noPreview': '暂无预览',
  'admin.form.offSaleNow': '暂不上架',
  'admin.form.onSaleNow': '立即上架',
  'admin.form.original': '原价（¥）',
  'admin.form.price': '售价（¥）',
  'admin.form.publish': '发布商品',
  'admin.form.salesTotal': '累计销量',
  'admin.form.saveEdit': '保存修改',
  'admin.form.saveFail': '保存失败，请稍后重试',
  'admin.form.saving': '保存中...',
  'admin.form.shelfStatus': '上架状态',
  'admin.form.shop': '所属店铺',
  'admin.form.shopDefault': '默认第一间店铺',
  'admin.form.sku': '商品编号 / SKU',
  'admin.form.skuPh': '例如：FRUIT-001',
  'admin.form.stock': '库存数量',
  'admin.form.sub': '维护商品展示信息、销售价格、库存与封面图',
  'admin.form.titleCreate': '新增商品',
  'admin.form.titleEdit': '编辑商品',
  'admin.inv.allStatus': '全部状态',
  'admin.inv.badStock': '库存数量必须为非负整数',
  'admin.inv.col.action': '操作',
  'admin.inv.col.name': '商品名称',
  'admin.inv.col.ratio': '库存占比',
  'admin.inv.col.safe': '安全库存',
  'admin.inv.col.sales': '累计销量',
  'admin.inv.col.sku': '商品编号',
  'admin.inv.col.status': '状态',
  'admin.inv.col.stock': '当前库存',
  'admin.inv.editStock': '修改库存',
  'admin.inv.empty': '暂无符合条件的库存记录',
  'admin.inv.gotoWarn': '查看预警',
  'admin.inv.loading': '库存数据加载中...',
  'admin.inv.normal': '库存正常',
  'admin.inv.prompt': '修改「{name}」库存（当前：{stock}）',
  'admin.inv.searchPh': '搜索商品名称 / SKU',
  'admin.inv.statusOk': '库存正常',
  'admin.inv.statusWarn': '库存预警',
  'admin.inv.sub': '查看商品库存健康度，支持快速更新库存数值',
  'admin.inv.title': '库存列表',
  'admin.inv.updateFail': '更新失败',
  'admin.inv.warnChip': '⚠ 预警 {n}',
  'admin.inv.warningOpt': '库存预警',
  'admin.invw.badge': '预警',
  'admin.invw.curStock': '当前库存 {n}',
  'admin.invw.empty': '当前没有低库存商品',
  'admin.invw.safeStock': '安全库存 {n}',
  'admin.invw.skuLine': 'SKU：{sku}',
  'admin.invw.sub': '优先处理库存低于安全阈值的商品，避免影响成交',
  'admin.invw.title': '库存预警',
  'admin.msg.markRead': '标记已读',
  'admin.msg.read': '已读',
  'admin.msg.sub': '查看订单提醒、库存预警与系统通知',
  'admin.msg.title': '消息中心',
  'admin.msg.unread': '未读',
  'admin.odetail.address': '收货地址',
  'admin.odetail.baseTitle': '订单基础信息',
  'admin.odetail.col.name': '商品名称',
  'admin.odetail.col.qty': '数量',
  'admin.odetail.col.sub': '小计',
  'admin.odetail.col.unit': '单价',
  'admin.odetail.created': '创建时间',
  'admin.odetail.itemsTitle': '商品明细',
  'admin.odetail.orderNo': '订单号',
  'admin.odetail.payTime': '支付时间',
  'admin.odetail.phone': '联系电话',
  'admin.odetail.status': '订单状态',
  'admin.odetail.total': '订单总额',
  'admin.odetail.user': '用户',
  'admin.order.action.cancel': '取消订单',
  'admin.order.action.complete': '确认完成',
  'admin.order.action.markPaid': '标记已付款',
  'admin.order.action.ship': '确认发货',
  'admin.order.col.actions': '操作',
  'admin.order.col.amount': '金额',
  'admin.order.col.created': '创建时间',
  'admin.order.col.no': '订单号',
  'admin.order.col.status': '状态',
  'admin.order.col.user': '用户',
  'admin.order.confirmUpdate': '确定将订单「{orderNo}」更新为「{label}」吗？',
  'admin.order.empty': '暂无符合条件的订单',
  'admin.order.loading': '订单数据加载中...',
  'admin.order.searchPh': '订单号 / 用户名（Enter 搜索）',
  'admin.order.status.cancelled': '已取消',
  'admin.order.status.completed': '已完成',
  'admin.order.status.pending_payment': '待付款',
  'admin.order.status.pending_shipping': '待发货',
  'admin.order.status.shipped': '已发货',
  'admin.order.sub': '查看订单状态、处理发货与流程推进',
  'admin.order.title': '订单管理',
  'admin.order.viewDetail': '查看详情',
  'admin.pdetail.cat': '商品分类',
  'admin.pdetail.loading': '商品详情加载中...',
  'admin.pdetail.orig': '原始价格',
  'admin.pdetail.price': '销售价格',
  'admin.pdetail.sales': '累计销量',
  'admin.pdetail.sku': '商品编号',
  'admin.pdetail.status': '上架状态',
  'admin.pdetail.stock': '库存数量',
  'admin.pdetail.sub': '查看商品完整信息与当前运营状态',
  'admin.pdetail.title': '商品详情',
  'admin.pdetail.updated': '更新时间',
  'admin.product.add': '+ 新增商品',
  'admin.product.allCat': '全部分类',
  'admin.product.allStatus': '全部状态',
  'admin.product.chipOff': '下架 {n}',
  'admin.product.chipOn': '在售 {n}',
  'admin.product.col.actions': '操作',
  'admin.product.col.cat': '分类',
  'admin.product.col.code': '编号',
  'admin.product.col.goods': '商品',
  'admin.product.col.name': '商品名称',
  'admin.product.col.price': '价格',
  'admin.product.col.sales': '销量',
  'admin.product.col.sku': 'SKU',
  'admin.product.col.status': '状态',
  'admin.product.col.stock': '库存',
  'admin.product.confirmDelete': '确定删除这个商品吗？删除后无法恢复。',
  'admin.product.confirmToggle': '确定将「{name}」{action}吗？',
  'admin.product.deleteFail': '删除失败，请重试',
  'admin.product.empty': '暂无符合条件的商品，尝试调整筛选条件或添加新商品',
  'admin.product.loading': '商品数据加载中...',
  'admin.product.maxPrice': '最高价 ¥',
  'admin.product.minPrice': '最低价 ¥',
  'admin.product.noDesc': '暂无商品描述',
  'admin.product.offChip': '下架',
  'admin.product.onSaleChip': '在售',
  'admin.product.opFail': '操作失败',
  'admin.product.panelTitle': '商品列表',
  'admin.product.searchPh': '搜索商品名称 / SKU（Enter 搜索）',
  'admin.product.sub': '集中管理商品信息、价格、库存与上下架状态',
  'admin.product.title': '商品管理',
  'admin.product.toggleOff': '下架',
  'admin.product.toggleOn': '上架',
  'admin.product.totalCount': '共 {n} 件',
  'admin.product.viewDetail': '详情',
  'admin.profile.accountReadonly': '账号（只读）',
  'admin.profile.basic': '基础资料',
  'admin.profile.displayName': '显示名称',
  'admin.profile.displayPh': '姓名/昵称',
  'admin.profile.email': '邮箱',
  'admin.profile.err.display': '显示名称不能为空',
  'admin.profile.err.save': '保存失败',
  'admin.profile.noName': '未设置名称',
  'admin.profile.phone': '手机号码',
  'admin.profile.pwdBtn': '修改密码',
  'admin.profile.pwdConfirm': '确认新密码',
  'admin.profile.pwdDoing': '修改中...',
  'admin.profile.pwdErrLen': '新密码至少 6 位',
  'admin.profile.pwdErrMatch': '两次输入的密码不一致',
  'admin.profile.pwdErrOld': '请输入当前密码',
  'admin.profile.pwdNew': '新密码',
  'admin.profile.pwdOk': '✓ 密码已更新',
  'admin.profile.pwdOld': '当前密码',
  'admin.profile.pwdPhConfirm': '再次输入新密码',
  'admin.profile.pwdPhNew': '至少 6 位',
  'admin.profile.pwdPhOld': '请输入当前密码',
  'admin.profile.pwdTitle': '修改密码',
  'admin.profile.save': '保存资料',
  'admin.profile.saved': '✓ 资料已更新',
  'admin.profile.saving': '保存中...',
  'admin.profile.sub': '维护当前运营账号的昵称、手机号与邮箱等资料',
  'admin.profile.title': '个人中心',
  'admin.shop.col.actions': '操作',
  'admin.shop.col.count': '商品数',
  'admin.shop.col.name': '名称',
  'admin.shop.col.status': '状态',
  'admin.shop.delConfirm': '确定删除该店铺？（有商品关联时会拒绝删除）',
  'admin.shop.delFail': '删除失败',
  'admin.shop.empty': '暂无店铺',
  'admin.shop.formAdd': '新增店铺',
  'admin.shop.formEdit': '编辑店铺',
  'admin.shop.list': '店铺列表',
  'admin.shop.loadFail': '加载店铺失败',
  'admin.shop.nameRequired': '店铺名称不能为空',
  'admin.shop.open': '营业',
  'admin.shop.ph.banner': '横幅图 URL',
  'admin.shop.ph.desc': '店铺简介',
  'admin.shop.ph.descEn': '英文简介',
  'admin.shop.ph.followers': '粉丝数（演示）',
  'admin.shop.ph.logo': 'Logo 图片 URL',
  'admin.shop.ph.name': '店铺名称',
  'admin.shop.ph.nameEn': '英文店铺名称',
  'admin.shop.ph.reviews': '好评基数（演示）',
  'admin.shop.ph.tagline': '一句话卖点',
  'admin.shop.ph.taglineEn': '英文卖点',
  'admin.shop.rest': '休息',
  'admin.shop.saveFail': '保存失败',
  'admin.shop.statusActive': '营业中',
  'admin.shop.statusOff': '休息中',
  'admin.shop.sub': '维护店铺档案、展示图与营业状态（与商品 shopId 关联）',
  'admin.shop.title': '店铺管理',
  'admin.status.disabled': '禁用',
  'admin.status.enabled': '启用',
  'admin.status.off': '下架',
  'admin.status.on': '在售',
  'admin.user.col.contact': '联系方式',
  'admin.user.col.login': '最近登录',
  'admin.user.col.name': '姓名',
  'admin.user.col.roles': '角色',
  'admin.user.col.status': '状态',
  'admin.user.col.user': '账号',
  'admin.user.sub': '查看平台运营账号、角色分配与账号状态',
  'admin.user.title': '用户管理',
  'dash.addProduct': '新增商品',
  'dash.categoryShare': '商品分类占比',
  'dash.hotMeta': '{sales} 件 · ¥{revenue}',
  'dash.hotTitle': '热销商品 TOP 5',
  'dash.level.high': '紧急',
  'dash.level.low': '一般',
  'dash.level.medium': '注意',
  'dash.loadFail': '加载仪表盘失败',
  'dash.loading': '仪表盘数据加载中…',
  'dash.refresh': '刷新',
  'dash.retry': '重试',
  'dash.stat.newProducts': '今日上新',
  'dash.stat.newProductsUnit': '件商品',
  'dash.stat.onSale': '在售商品',
  'dash.stat.onSaleUnit': '件在售',
  'dash.stat.ordersUnit': '笔订单',
  'dash.stat.sales': '今日销售额',
  'dash.stat.warning': '库存预警',
  'dash.stat.warningAction': '立即处理 →',
  'dash.subtitle': '以实时数据掌握商品、订单、库存与运营表现',
  'dash.title': '运营概览',
  'dash.todoTitle': '待处理事项',
  'dash.trendHint': '销售额（¥）',
  'dash.trendTitle': '近 7 日销售趋势',
  'dash.wanSuffix': ' 万',
  'menu.category': '分类管理',
  'menu.dashboard': '仪表盘',
  'menu.inventory': '库存管理',
  'menu.inventoryList': '库存列表',
  'menu.inventoryWarning': '库存预警',
  'menu.message': '消息中心',
  'menu.order': '订单管理',
  'menu.orderList': '订单列表',
  'menu.permission': '权限管理',
  'menu.product': '商品运营',
  'menu.productCreate': '新增商品',
  'menu.productList': '商品列表',
  'menu.profile': '个人中心',
  'menu.roleList': '角色管理',
  'menu.shop': '店铺管理',
  'menu.userList': '用户管理',
  'perm.category.create': '分类新建',
  'perm.category.delete': '分类删除',
  'perm.category.update': '分类编辑',
  'perm.category.view': '分类查看',
  'perm.inventory.update': '库存调整',
  'perm.inventory.view': '库存查看',
  'perm.inventory.warning': '库存预警',
  'perm.message.view': '消息中心',
  'perm.order.update': '订单处理',
  'perm.order.view': '订单查看',
  'perm.product.create': '商品新建',
  'perm.product.delete': '商品删除',
  'perm.product.update': '商品编辑',
  'perm.product.view': '商品查看',
  'perm.profile.view': '个人中心',
  'perm.role.view': '角色管理',
  'perm.shop.create': '店铺新建',
  'perm.shop.delete': '店铺删除',
  'perm.shop.update': '店铺编辑',
  'perm.shop.view': '店铺查看',
  'perm.user.view': '用户管理',
  'role.loadFail': '加载角色列表失败',
  'role.subtitle': '查看角色职责范围与可访问权限集合',
  'role.title': '角色管理',
};
